<template>
  <div class="GALLERY">
    <div class="content">
      <div class="up">
        <div class="uptext maxtext">PERSPECTIVE</div>
        <swiper :options="swiperOption" class="mySwiper" ref="mySwiperA" virtual>
          <swiper-slide
            v-for="(data, index) in imglist"
            :key="index"
          >
            <img @click="setpop('img',index)" :src="Main.imgserve + data" alt=""
          /></swiper-slide>
        </swiper>
      </div>
      <div class="linetext"></div>
      <div class="down">
        <div class="downtext maxtext">VIDEO</div>
        <swiper :options="swiperOptiontwo" class="mySwiper" ref="mySwiperB">
          <!-- <swiper-slide class="swiper-slidetwo">
            <img
                @click="setpop('video',0)"
              :src="Main.imgserve + '/GALLERY/G_I01-South_View_Day.png'"
              alt=""
            /> </swiper-slide> -->
          <swiper-slide class="swiper-slidetwo">
            <img @click="setpop('video',0)" :src="Main.imgserve + '/video/videos.png'" alt="" />
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="left_imgcontent">
      <h2 style="margin-top: 2vh;text-align: end; width: 80%">GALLERY</h2>
      <!-- <div style="text-align: start; width: 80%; margin-left: 10%">
        <h4>THE OASIS</h4>
        <p>Simple intro of the selected images / video.</p>
      </div> -->
    </div>

    <div class="pop" v-show="gallerypoptype">
      <div style="width: 80%; height: 80%; margin: auto">
        <!-- <img :src="Main.imgserve + '/GALLERY/G_PL02.png'" alt=""> -->
        <swiper :options="swiperOptions" class="mySwiper" ref="POPSwiper">
          <swiper-slide v-for="(data, index) in nowmedia" :key="index ">
            
            <img style="position:relative;" v-if="poptypes =='img'" :src="Main.imgserve + data" alt="">
          <!-- <span style="position: absolute;bottom: 10px;left:0px;color: white;">All images are for illustration purpose only</span> -->
            <video v-if="poptypes =='video' && Main.imgserve !='./091AvenueSouth/'"
            :id="'video'+index"
              style="max-width: 100%; max-height: 100%"
              :src="Main.imgserve + '/video/MARKETING.mp4'"
              controls
            ></video>
            <video v-if="poptypes =='video' && Main.imgserve =='./091AvenueSouth/'"
            :id="'video'+index"
              style="max-width: 100%; max-height: 100%"
              :src="Main.imgserve + '/video/MARKETING.webm'"
              controls
            ></video>
          </swiper-slide>
        </swiper>
      </div>

      <div class="leftbtn" >
        <div class="swiper-button-prev">
         <img :src="Main.imgserve + '/btn/G_Arrow left.png'" alt="" />
        </div>
        <div class="swiper-button-next">
       <img :src="Main.imgserve + '/btn/G_Arrow right.png'" alt="" />
        </div>


      </div>
      <div class="rightbtn " >
        <div class="swiper-button-next">
       <img :src="Main.imgserve + '/btn/G_Arrow right.png'" alt="" />
        </div>
        <div class="swiper-button-prev">
         <img :src="Main.imgserve + '/btn/G_Arrow left.png'" alt="" />
        </div>
      </div>
      <div
        @click="gallerypoptype = !gallerypoptype,offvideo()"
        style="position: absolute; right: 2vw; top: 2vh; width: 2vw"
      >
        <img :src="Main.imgserve + '/btn/BACK.png'" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import Swiper2, { Navigation, Pagination, Autoplay } from "swiper";
import SwiperCore, { EffectFade } from "swiper";
import "swiper/swiper.less";
import "swiper/components/effect-fade/effect-fade.less";
import "swiper/components/pagination/pagination.min.css";
Swiper2.use([Navigation, Pagination, Autoplay]);
SwiperCore.use([EffectFade]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      gallerypoptype: false,
      nowmedia: "",
      imglist: {
        0: "/GALLERY/G_I01-South_View_Day.png",
        1: "/GALLERY/G_I02-North_View_Day.png",
        2: "/GALLERY/G_I03-Silat Additional Angle Pano.png",
        3: "/GALLERY/G_I04-Sky_Function_Room.png",
        4: "/GALLERY/G_I05-Sky Terrace.png",
        5: "/GALLERY/G_I06-Street_View_Night.png",
        // 6: "/GALLERY/G_I07-The_Park_&_Heritage.png",
        6: "/GALLERY/G_I08-Dropoff_Day_New.png",
        7: "/GALLERY/G_I09-Pool_and_Vert_Garden_Day.png",
        8: "/GALLERY/G_I10-The_Wilderness_Park_Connector.png",
        9: "/GALLERY/G_I11-The_Wilderness_Fantasy_Adventure.png",
        10: "/GALLERY/G_I12-The Oasis.png",
        11: "/GALLERY/G_I13-50M Lap_Pool_&_Spa_Poo.png",
        12: "/GALLERY/G_I14-Onsen_Day.png",
        13: "/GALLERY/G_I15-View_from_the_Sanctuary.png",
        14: "/GALLERY/G_I16-Gym.png",
        15: "/GALLERY/G_I17-FunctionRoom01.png",
        16: "/GALLERY/G_I18-FunctionRoom02.png",
        17: "/GALLERY/G_I19-FunctionRoom03.png",
        18: "/GALLERY/G_I20-Silat Ave 1BR.png",
        19: "/GALLERY/G_I21-3BR - Living Dining.png",
        20: "/GALLERY/G_I22-3BR - 4BR (BC)-Living.png",
        21: "/GALLERY/G_I23-4BR (BC)-Master.png",
        22: "/GALLERY/G_I26-Balcony View_Night.png",
        23: "/GALLERY/G_I27-Facade Close up_Day-.png",
      },

      videolist: {
        0: "/video/MARKETING.mp4",
        // 1: "/video/MARKETING.mp4",
      },
      swiperOption: {
        slidesPerView: 5,
        slideToClickedSlide: true,
        loop: true, // 循环
        spaceBetween: 10,
        freeMode: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
      },
        swiperOptiontwo: {
        slidesPerView: 2,
        slideToClickedSlide: true,
        loop: false, // 循环
        spaceBetween: 10,
        freeMode: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
      },
      swiperOptions: {
        // autoplay: true, // 自动播放
        loop: false, // 循环
        initialSlide: 1, //初始值
        slidesPerView: 1,
        grabCursor: true,
        centeredSlides: true,
        clickable: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
        navigation: {
          // 无效
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          hideOnClick: true,
        },
        on:{
            init:()=>{
              // 初始化
            },
            slideChangeTransitionEnd:()=>{ // 元素切换完成后回调函数
                var videolist = document.getElementsByTagName('video')
                for (let index = 0; index < videolist.length; index++) {
                  if(this.$refs.POPSwiper.$swiper.activeIndex == index){
                    videolist[index].play()
                  }else{
                    videolist[index].pause()
                  }
                }
                // console.log(videolist,this.$refs.POPSwiper.$swiper)
            }

        }
      },
    };
  },
  methods: {
    offvideo(){ // 关闭弹窗
      var videolist = document.getElementsByTagName('video')
      console.log(videolist)
      for (let index = 0; index < videolist.length; index++) {
        videolist[index].pause()
      }
    },
      setpop(type,index){

          // if (this.$refs.POPSwiper.$swiper.realIndex != Number(index)) return
          // console.log(this.$refs.mySwiperA.$swiper,Number(index))
          this.nowmedia = this.imglist
          this.nowindex = index
          this.poptypes = type
          console.log(this.nowmedia,index)
          if(type =='video'){
            this.nowmedia = this.videolist
          }
          this.gallerypoptype = true
          this.$refs.POPSwiper.$swiper.slideTo(Number(index))
          console.log(Number(index))
          setTimeout(()=>{ // 延时执行、等待弹窗元素渲染时间、然后播放当前选中视频
            if(type =='video'){
              var videoel = document.getElementById(`video${this.nowindex}`)
              console.log(videoel)
              videoel.play()
          }
          },500)


      }


  },
  mounted() {},
};
</script>

<style lang="less">
.GALLERY {
  widows: 100%;
  height: 100%;
  margin: 0;
  .content {
    width: 75%;
    height: 100%;
    margin-left: 5vw;
    .up {
      width: 100%;
      height: 48%;
      position: relative;
      .uptext {
        position: absolute;
        right: 20%;
        top: 40%;
      }
    }
    .linetext {
      width: 92%;
      height: 3px;
      margin-bottom: 10px;
      margin: 12px auto;
      background: #77746e;
    }
    .down {
      width: 100%;
      height: 48%;
      transform-style: preserve-3d;
      transform: rotateY(180deg) rotatex(180deg);
      .downtext {
        position: absolute;
        right: 20%;
        top: 60%;
        transform-style: preserve-3d;
        transform: rotateY(180deg) rotatex(180deg);
      }
    }

    .swiper-wrapper {
      align-items: flex-end;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
    }

    .swiper-slidetwo {
      transform-style: preserve-3d;
      transform: rotateY(180deg) rotatex(180deg);
    }

    .swiper-slide {
      background: rgba(230, 229, 229, 0.15);;
      height: 35%;
      opacity: 0.5;
      text-align: center;
      font-size: 18px;
      //   background: #fff;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }

    .swiper-slide img {
      display: block;
        // width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .swiper-slide-active {
      transition:height 300ms;
      height: 70%;
      width: 30vw !important;
      opacity: 1;
    }
  }
  .pop {
    background-color: rgb(237, 230, 220);
    position: fixed;
    top: 0;
    left: 0;
    // background: white;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    // display: none;
    .mySwiper {
      height: 100%;
      width: 100%;
      margin: auto;
    }
    .swiper-button-prev,
    .swiper-button-next {
      top: auto;
    }
    .swiper-button-prev{
      left: auto;
      right: 10px;
    }
    .swiper-button-next{
      right: auto;
      left: 10px;
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      content: none;
    }
    .leftbtn {
      position: absolute;
      left: 2vw;
      bottom: 5vh;
    }
    .rightbtn {
      position: absolute;
      right: 2vw;
      bottom: 5vh;
    }
    .swiper-slide{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>